import { useEffect } from 'react';
import useCustomHook from '@/hooks/useCustomHook';
import { createActivityTypeConf } from '@/modules/activities/ActivityTypesConf';

export default function useCoverMenu({ activity, activityConf, gameActions }) {
  const { state, actions } = useCustomHook({
    defaultState: {
      screen: 'TYPE',
      availableTypes: [],
    },
  });

  useEffect(() => {
    if (activity) {
      if (activityConf?.miniactivityType) {
        actions.setState({
          screen: 'START',
        });
      } else if (state.availableTypes.length == 0) {
        const activityTypeConf = createActivityTypeConf(activity);

        const availableTypes = activityTypeConf.miniactivities.map(
          (miniactivity) => miniactivity.miniactivityType
        );

        if (availableTypes.length == 1) {
          gameActions.setGameConf({
            ...activityTypeConf.miniactivities[0],
          });
        }

        actions.setState({
          availableTypes,
        });
      } else {
        actions.setState({
          screen: 'TYPE',
        });
      }
    }
  }, [activity, activityConf]);

  return { state, actions };
}
